 const allReviewsColumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "imageUrl",
    label: "Image",
  },
  {
    key: "name",
    label: "Product ",
  },
  {
    key: "userName",
    label: "User",
  },
  {
    key: "isApproved",
    label: "Approved",
  },
  {
    key: "date",
    label: "Date",
  },
  
  
  {
    key: "actions",
    label: "Actions",
  },
];

export { allReviewsColumn };
